import request from './request'

export const teacherApi = {
  // 导师列表
  listTeacher (params) {
    return request.get('/teachers', { params: params })
  },
  // 新增导师
  addTeacher (data) {
    return request.post('/teacher', data)
  },
  // 删除导师
  deleteTeacher (teacherId) {
    return request.delete('/teachers/' + teacherId)
  },
  getTeacher (teacherId) {
    return request.get('/teachers/' + teacherId)
  },
  // 修改导师信息
  updateTeacher (id, data) {
    return request.put('/teachers/' + id, data)
  },
}

export default teacherApi
